import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { timeElapsed } from '../../../helpers';

import style from './index.module.scss';

function ToAnswer({ questionTitle, questionId, answersLength, updatedAt }) {
  return (
    <>
      <h4 className={style.title}>{questionTitle}</h4>
      <p className={`text-muted ${style['num-of-answers']}`}>
        <Link
          to={{
            pathname: `/question/${encodeURI(questionTitle)}`,
            state: {
              questionId,
            },
          }}
          className={style.link}
        >
          {answersLength} answers
        </Link>
      {" "}· Last followed {timeElapsed(updatedAt)}
      </p>
      <div className={`col-12 ${style['col--actions']}`}>
        <span className={style.action}>
          <i className="fas fa-edit" /> Answer
        </span>
        <span className={style.action}>
          <i className="fas fa-times" /> Pass
        </span>
        <span className={style.action}>
          <i className="fas fa-rss" /> Follow
        </span>
      </div>
    </>
  );
}

ToAnswer.propTypes = {
  questionTitle: PropTypes.string.isRequired,
  questionId: PropTypes.string.isRequired,
  answersLength: PropTypes.number.isRequired,
  updatedAt: PropTypes.string.isRequired,
};

export default ToAnswer;
